import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useState } from 'react';
import useClickOutside from '../../../Hooks/useClickOutside';

export interface INotificationSettingsProps {
}

export function NotificationSettings(props: INotificationSettingsProps) {





    const [ehtModalOpen, setEhtModalOpen] = React.useState(false);
    const [ehtText, setEhtText] = useState('EHT')
    const ethModalRef = React.useRef<HTMLHeadingElement>(null);
    useClickOutside(ethModalRef, () => setEhtModalOpen(false))


    return (
        <div className="text-left mt-8 notifications_settings_main_box w-full md:w-8/12 lg:w-7/12 xl:w-6/12 pb-44">

            <h1 className="text-xl sm:text-2xl xl:text-3xl font-extrabold text-cusBlack dark:text-white">Notification Settings</h1>
            <p className="text-xs sm:text-base text-l-LightBlack dark:text-[#8987AF] mt-2">Select which notifications you would like to receive for 0x9cd4...0667</p>

            <div className="mt-8">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Item Sold</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When someone purchased one of your items</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="itemSold" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="itemSold" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Bid Activity</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When someone bids on one of your items</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="bidActivity" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="bidActivity" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Price Change</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When an item you made an offer on changes in price</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="priceChange" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="priceChange" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Auction Expiration</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When a timed auction you created ends</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="auctionExpiration" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="auctionExpiration" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Outbid</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When an offer you placed is exceeded by another user</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="outbid" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="outbid" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Owned Item Updates</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When a significant update occurs for one of the items you have purchased on OpenSea</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="ownedItemUpdates" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="ownedItemUpdates" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Successful Purchase</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">When you successfully buy an item</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="successfulPurchesed" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="successfulPurchesed" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">UNC Newsletter</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">Occasional updates from the UNC team</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="uncNewsletter" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="uncNewsletter" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>

            <div className="mt-0">
                <div className="flex justify-between items-center">
                    <div>
                        <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Minimum Bid Threshold</h4>
                        <p className="xs:w-11/12 2xl:w-full text-xs sm:text-sm text-cusBlack dark:text-cusBlueWhite">Receive notifications only when you receive offers with a value greater than or equal to this amount of ETH.</p>
                    </div>

                    <div className="flex items-center justify-center">
                        <label htmlFor="minimumBidThreshold" className="flex items-center cursor-pointer">
                            <div className="relative">
                                <input type="checkbox" id="minimumBidThreshold" name="postOnActivity" className="sr-only" />
                                <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                            </div>
                        </label>
                    </div>
                </div>
            </div>

            <div className="border-b border-[#B7B7B7] dark:border-[#201753] my-4"></div>





            <div className="mt-8">
                <h4 className="text-cusBlack font-extrabold dark:font-medium dark:text-white text-sm sm:text-lg">Minimum Bid Threshold</h4>
                <p className="text-sm sm:text-cusBlack dark:text-cusBlueWhite">Receive notifications only when you receive offers with a value greater than or equal to this amount of ETH.</p>

                <div className="lightBlueBg p-5 rounded-xl mt-3 relative">
                    <input type="text" name="" id="" placeholder="0.005"
                        className="xs:text-xs sm:text-base bg-transparent w-full h-full outline-none text-cusBlack dark:text-white pr-14" />
                    <div className="absolute top-3 right-5" onClick={() => setEhtModalOpen(!ehtModalOpen)}>
                        <button className="bg-[#EFEFEF] dark:bg-[#363375] py-1 px-2 rounded flex justify-center items-center">
                            <svg className="w-[8px] lg:w-[13px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                            </svg>


                            <p className="text-l-LightBlack dark:text-[#6F6DAB] text-xl font-black mx-2">{ehtText}</p>
                            <svg xmlns="http://www.w3.org/2000/svg" className={`${ehtModalOpen ? 'rotate-180' : ''} w-3 lg:w-4 stroke-l-LightBlack dark:stroke-[#6f6dab] transition-all`} viewBox="0 0 18.657 11.328">
                                <path id="Path_1027" data-name="Path 1027" d="M3208,826l6.5,6.5,6.5-6.5" transform="translate(-3205.171 -823.172)" fill="none" stroke="" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} />
                            </svg>
                        </button>
                    </div>

                    <AnimatePresence>
                        {ehtModalOpen &&
                            <motion.div
                                initial={{ height: 0, width: 0 }}
                                animate={{ height: '', width: '' }}
                                exit={{ height: 0, width: 0 }}
                                ref={ethModalRef}
                                className="absolute right-5 top-14 w-44 bg-white shadow-2xl dark:bg-[#363375] rounded overflow-hidden">
                                {["EHT 1", "EHT 2", "EHT 3", "EHT 4",].map(item =>
                                    <button className="w-full py-2 hover:bg-gray-200 hover:dark:bg-[#3c379d] px-3 flex justify-start items-center" key={item}
                                        onClick={() => { setEhtModalOpen(false); setEhtText(item) }}>
                                        <svg className="w-[8px] lg:w-[13px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                            <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                            <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                            <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                            <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                            <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                            <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                        </svg>
                                        <p className="text-l-LightBlack dark:text-white text-lg font-black ml-2">{item}</p>
                                    </button>
                                )}
                            </motion.div>
                        }
                    </AnimatePresence>
                </div>
            </div>









        </div>
    );
}
